import React from "react";

import { useOpenModal } from "@/components/modal/utils/openModal";

import { MediaItemRendererPropTypes, SliderModal } from "../Slider.modal";
import { SliderPhoto } from "../components/slider-photo";

type ManProfileSliderMedia = {
  src: string;
};

export type ManProfileSliderPropTypes = {
  data: ManProfileSliderMedia[];
};

export const ManProfileSlider: React.FC<ManProfileSliderPropTypes> = ({
  data,
}) => {
  const { removeOne } = useOpenModal();

  const MemoizedRenderer = React.useCallback((prop: RendererProps) => {
    return <Renderer {...prop} />;
  }, []);

  return (
    <SliderModal
      media={data}
      onClose={removeOne}
      MediaItemRenderer={MemoizedRenderer}
    />
  );
};

type RendererProps = MediaItemRendererPropTypes<ManProfileSliderMedia[]>;

const Renderer: React.FC<RendererProps> = ({ item, index, isSelected }) => {
  return (
    <>
      <SliderPhoto
        src={item.src}
        alt={`prohile-photo-${index}`}
        isSelected={isSelected}
        id={`profile-photo-${index}`}
      />
    </>
  );
};
